import { PaginatedData, RawData } from "api/model/BaseApiResponseModel";

export function isPaginatedData<T>(data: any): data is PaginatedData<T> {
  return (
    data && Array.isArray(data.items) && typeof data.pagination === "object"
  );
}

export function isRawData<T>(data: any): data is RawData<T> {
  return data && "raw" in data;
}
